import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CirrusDividerModule } from '../divider/cirrus-divider.module';
import { SectionComponent } from './section.component';

@NgModule({
  imports: [CommonModule, CirrusDividerModule],
  declarations: [SectionComponent],
  exports: [SectionComponent]
})
export class SectionModule {}
